let selectedVariantId = null;

document.addEventListener("click", (e) => {
  const openBtn = e.target.closest("[data-modal]");
  if (openBtn) {
    const modal = document.querySelector(openBtn.dataset.modal);
    if (modal) modal.setAttribute("open", "");
  }

  const closeBtn = e.target.closest("[data-close]");
  if (closeBtn) {
    const modal = closeBtn.closest("modal-dialog");
    if (modal) modal.removeAttribute("open");
  }
});
document.addEventListener("click", (e) => {
  const svg = e.target.closest("svg.quick-plus-svg");
  if (!svg) return;

  const variantId = svg.getAttribute("data-variant-id");
  if (!variantId) return;

  selectedVariantId = variantId;

  const modal = document.querySelector(".quick-add-modal-la");
  if (!modal) return;

  modal.classList.add("active");
  document.body.style.overflow = "hidden";

  document.querySelectorAll(".variant-button-la")
    .forEach(btn => btn.classList.remove("active"));

  const activeVariant = document.querySelector(
    `.variant-button-la[data-variant-id="${variantId}"]`
  );

  if (activeVariant) {
    activeVariant.classList.add("active");
  }
});


document.addEventListener("click", (e) => {

  const variantBtn = e.target.closest(".variant-button-la");
  if (!variantBtn) return;

  document.querySelectorAll(".variant-button-la")
    .forEach(btn => btn.classList.remove("active"));

  variantBtn.classList.add("active");

  selectedVariantId = variantBtn.dataset.variantId;

});


document.addEventListener("click", async (e) => {

  const addBtn = e.target.closest(".quick-add-cart-la");
  if (!addBtn) return;

  if (!selectedVariantId) return;

  const loader = addBtn.querySelector(".loading-overlay");
  const text = addBtn.querySelector(".btn-text");
  const success = addBtn.querySelector(".btn-success");

  addBtn.style.pointerEvents = "none";

  if (loader) loader.classList.remove("hidden");
  if (text) text.style.opacity = "0";

  try {

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(selectedVariantId), quantity: 1 }],
      }),
    });

    const data = await res.json();
    if (data.status) throw new Error(data.description);

    if (loader) loader.classList.add("hidden");

    if (success) {
      success.style.display = "block";
      success.classList.remove("hidden");
      if (text) text.style.opacity = "0";
    }

    const html = await fetch("/?section_id=cart-drawer-la")
      .then(r => r.text());

    const doc = new DOMParser()
      .parseFromString(html, "text/html");

    const newDrawer = doc.querySelector(".cart-drawer-la");
    const oldDrawer = document.querySelector(".cart-drawer-la");

    const cartBubble = document.querySelector(".cart-count-bubble-la");
    const cartCount = document.querySelector(".cart-count-header-la");

    if (cartCount && cartBubble) {
      const currentCount = parseInt(cartCount.textContent) || 0;
      const newCount = currentCount + 1;

      cartCount.textContent = newCount;

      if (newCount > 0) {
        cartBubble.classList.add("product-form-active-la");
      }
    }

    if (newDrawer && oldDrawer) {
      oldDrawer.replaceWith(newDrawer);
      newDrawer.classList.add("cart-drawer-active-la");
      document.body.style.overflow = "hidden";
    }

    document
      .querySelector(".quick-add-modal-la")
      ?.classList.remove("active");

    setTimeout(() => {
      if (success) success.classList.add("hidden");
      success.style.display = "block";
      if (text) text.style.opacity = "1";
      addBtn.style.pointerEvents = "";
    }, 1500);

  } catch (err) {

    console.error("Add variant error:", err);

    if (loader) loader.classList.add("hidden");
    if (text) text.style.opacity = "1";
    addBtn.style.pointerEvents = "";

  }

});


document.addEventListener("click", (e) => {

  if (e.target.closest(".quick-add-close-la")) {

    document
      .querySelector(".quick-add-modal-la")
      ?.classList.remove("active");

    document.body.style.overflow = "";

  }
const modal = document.querySelector(".quick-add-modal-la");
  const content = e.target.closest(".quick-add-content-la");
  if (modal && modal.classList.contains("active") && !content && e.target === modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
});
  